// AUTO-GENERATED at build time by scripts/build-supabase-config.mjs
// Do not edit manually — values come from environment variables.
// gitignored — never commit this file.

export const SUPABASE_URL = 'https://iguwecrinpwxplztyggl.supabase.co';
export const SUPABASE_KEY = 'sb_publishable_F_kM2lUAyS9eEex4Or9LTA_4LSoztJB';
export const SUPABASE_PUBLISHABLE_KEY = SUPABASE_KEY;
export const TRUSTED_BYPASS_EMAILS = [];
export const MASTER_EMAIL = "";
export const HCAPTCHA_SITE_KEY = "387c60de-63e2-4954-840e-4dc871ae0534";
export const INSTALL_KIND = "saas";
